<section class="common-lateral-panel"
  [attr.aria-labelledby]="'box-protection-title-' + boxProtection.id"
  [ngClass]="{'common-lateral-panel--expand':boxProtection.fullScreen}">
  <div class="common-section-title__lp-container">
    <div class="common-section-title__lp-title-icon">
      <i aria-hidden="true"
      [class]="boxProtection.icon + ' common-icon__lg common-icon__main'"></i>
      <h2 class="common-section-title__lp-label-text"
        [id]="'box-protection-title-' + boxProtection.id"
        [afTranslate]="boxProtection.title"></h2>
    </div>
  </div>
  <div class="common-lateral-panel__body-protection">
    <p class="common-lateral-panel__subtitle-protection"
      [afTranslate]="boxProtection.subTitle">
    </p>
    <div class="common-lateral-panel__body-text-protection"
      role="region"
      [attr.aria-label]="boxProtection.title"
      [ngClass]="{'common-lateral-panel__body-text-protection--minimized': !boxProtection.fullScreen}"
      [id]="'box-protection-'+boxProtection.id"
      [innerHTML]="data">
    </div>
  </div>
  @if(boxProtection.fullScreen || showMoreInfo()){
    <div class="common-lateral-panel__expand-block-right">
      <button type="button"
        class="common-button__expand-toned"
        [attr.aria-expanded]="boxProtection.fullScreen"
        [attr.aria-controls]="'box-protection-'+boxProtection.id"
        [attr.aria-label]="(boxProtection.fullScreen ? 'common.collapse' : 'common.expand') | afTranslate"
        (click)="boxProtection.fullScreen = !boxProtection.fullScreen">
        <i aria-hidden="true" class=" common-icon__md"
          [ngClass]="boxProtection.fullScreen? 'lf-icon-angle-up': 'lf-icon-angle-down'"></i>
        <span class="common-button__expand-label-text"
          [afTranslate]="boxProtection.fullScreen?'common.collapse':'common.expand'"></span>
      </button>
    </div>
  }
</section>
